import { getCompany, useApiQuery } from '@hum/api';
import { Result } from '@hum/common';
import { Company } from '@hum/types';

export const useCompany = (companyId?: string) => {
  const { data: currentCompany, isLoading } = useApiQuery(getCompany, {
    params: { uuid: companyId! },
    enabled: !!companyId,
  });

  return {
    data: currentCompany,
    loaded: !isLoading,
  } as Result<Company>;
};
